import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'metersAsMiles' })
class MetersAsMilesPipe implements PipeTransform {
  transform(meters: any): number {
    return meters / 1609.344
  }
}

export { MetersAsMilesPipe };
